// Separación de los pagos de un cierre de caja en efectivo vs tarjeta.
//
// Extraído de CierreDeCajaForm para poder testearlo: el `Tipo_Pago` de cada
// pago lo resuelve `formaDePagoSyncService` (hoy derivado del `Code`, con
// TRANS_BANC contando como efectivo). Acá solo se agrupa por ese valor.
//
// Convención de signos: las facturas llegan con `Amount` positivo y las notas
// de crédito con `Amount` negativo.

// Trabajar en centavos evita los errores de coma flotante al sumar importes.
const toCents = (value) => {
	const safe = value ?? 0;
	return Math.round((safe + Number.EPSILON) * 100);
};

const fromCents = (cents) => cents / 100;

/**
 * @param {Array<{ Tipo_Pago?: string, Amount?: number }>} pagos
 * @returns {{
 *   facturasEfectivo: number, facturasTarjeta: number,
 *   notasCreditoEfectivo: number, notasCreditoTarjeta: number,
 *   totalEfectivo: number, totalTarjeta: number, total: number
 * }}
 */
export const calcularTotalesPorTipoPago = (pagos = []) => {
	const esEfectivo = (pago) => pago.Tipo_Pago === "Efectivo";
	const esTarjeta = (pago) => pago.Tipo_Pago === "Tarjeta";

	// Facturas (Amount > 0)
	const facturasEfectivoCents = pagos
		.filter((pago) => esEfectivo(pago) && (pago.Amount || 0) > 0)
		.reduce((sum, pago) => sum + toCents(pago.Amount || 0), 0);

	const facturasTarjetaCents = pagos
		.filter((pago) => esTarjeta(pago) && (pago.Amount || 0) > 0)
		.reduce((sum, pago) => sum + toCents(pago.Amount || 0), 0);

	// Notas de crédito (Amount < 0)
	const notasCreditoEfectivoCents = pagos
		.filter((pago) => esEfectivo(pago) && (pago.Amount || 0) < 0)
		.reduce((sum, pago) => sum + Math.abs(toCents(pago.Amount || 0)), 0);

	const notasCreditoTarjetaCents = pagos
		.filter((pago) => esTarjeta(pago) && (pago.Amount || 0) < 0)
		.reduce((sum, pago) => sum + Math.abs(toCents(pago.Amount || 0)), 0);

	const totalEfectivoCents = facturasEfectivoCents - notasCreditoEfectivoCents;
	const totalTarjetaCents = facturasTarjetaCents - notasCreditoTarjetaCents;

	return {
		facturasEfectivo: fromCents(facturasEfectivoCents),
		facturasTarjeta: fromCents(facturasTarjetaCents),
		notasCreditoEfectivo: fromCents(notasCreditoEfectivoCents),
		notasCreditoTarjeta: fromCents(notasCreditoTarjetaCents),
		totalEfectivo: fromCents(totalEfectivoCents),
		totalTarjeta: fromCents(totalTarjetaCents),
		total: fromCents(totalEfectivoCents + totalTarjetaCents),
	};
};
